import { useEffect, useState } from "react";
import {
  categoryColumns,
  resources_EN,
} from "../GenericServices/componentUtils";
import { getService, PostService } from "../GenericServices/genericService";
import DataGrid from "../Grid/DataGrid";
import UpdateCategoryModal from "../UpdateCategoryModal/UpdateCategoryModal";
import Swal from "sweetalert2";
import AddCategoryModal from "../AddCategoryModal/AddCategoryModal";

const AdminCategories = ({
  showEditCategoryModal,
  setShowEditCategoryModal,
  showAddCategoryModal,
  setShowAddCategoryModal,
}) => {
  const [category, setCategory] = useState([]);
  const [editCategoryData, setEditCategoryData] = useState({});
  useEffect(() => {
    getCategoryAPI();
  }, []);

  const getCategoryAPI = () => {
    const url = "myNewAPI/get_category.php";
    getService(url, {}, setCategoryData);
  };

  const setCategoryData = (response) => {
    setCategory(response.category);
  };

  /* Edit Category Data */
  const handleEditCategory = (categoryData) => {
    setEditCategoryData(categoryData);
    setShowEditCategoryModal(true);
  };

  /* Delete Category */
  const deleteAPI = (catId) => {
    const url = "myNewAPI/delete_category.php";
    const data = { cat_id: catId };
    PostService(url, data, modal);
  };

  /* Delete Confirmation Modal */
  const deleteModal = (categoryData) => {
    Swal.fire({
      title: "Do you want to delete the category?",
      showCancelButton: true,
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteAPI(categoryData.cat_id);
      }
    });
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        getCategoryAPI();
      }
    });
  };

  return (
    <>
      <UpdateCategoryModal
        showEditCategoryModal={showEditCategoryModal}
        setShowEditCategoryModal={setShowEditCategoryModal}
        categoryData={editCategoryData}
        getCategoryAPI={getCategoryAPI}
      />

      <AddCategoryModal
        showAddCategoryModal={showAddCategoryModal}
        setShowAddCategoryModal={setShowAddCategoryModal}
        getCategoryAPI={getCategoryAPI}
      />
      <div className="bg-white shadow overflow-hidden sm:rounded-md">
        <DataGrid
          data={category}
          columns={categoryColumns}
          showActions={true}
          itemsPerPage={10}
          onRowClick={(row) => console.log(row)}
          onEdit={(categoryData) => {
            handleEditCategory(categoryData);
          }}
          onDelete={(categoryData) => {
            // Handle delete - show confirmation, then delete
            deleteModal(categoryData);
          }}
        />
      </div>
    </>
  );
};

export default AdminCategories;
